import React, { useEffect } from 'react';
import AppSuspense from '../AppSuspense';
import AppErrorBoundary from '../AppErrorBoundary';
import Box from '@mui/material/Box';
import AppContentViewWrapper from './AppContentViewWrapper';
import { SxProps } from '@mui/system';
import FloatingApp from '../../../../../apps/art-cloud/src/modules/floatingApp';
import { useAuthUser } from '@crema/hooks/AuthHooks';
import { MenusType } from '@crema/models/account';

type AppContentViewProps = {
  sxStyle?: SxProps;
  routes: React.ReactElement | null;
};

const AppContentView: React.FC<AppContentViewProps> = ({ routes, sxStyle }) => {
  // const props = useAuthUser();

  // const { isAuthenticated, user, menus } = useAuthUser();

  const myUrl = process.env.NX_APPLICATION || '';
  const isArtCloud = myUrl === 'ac';
  const isLocalhost = myUrl.indexOf('local') !== -1;

  // const isViewFloating =
  //   isAuthenticated &&
  //   (user?.channel.inflowPath || '') === 'CAFE24' &&
  //   !(menus || []).find((item: MenusType) => item.id === 74) &&
  //   isArtCloud;

  const isInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      // cross-origin 접근 불가 → 보통 iframe 내부임
      return true;
    }
  };
  useEffect(() => {
    // iframe 내부에서는 챗봇 버튼을 노출시키지 않는다.
    if (isInIframe()) return;

    if (isArtCloud || isLocalhost) {
      const scriptUrl = 'https://static.zdassets.com/ekr/snippet.js?key=5857c61d-8d3b-4ccc-b1ea-835ca535369f';
      if (document.querySelector(`script[src="${scriptUrl}"]`)) return;

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.id = 'ze-snippet';
      document.body.appendChild(script);
    }
  }, []);

  //배경변경
  return (
    <AppContentViewWrapper>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          padding: '30px',
          //         background: 'white',
          ...sxStyle,
        }}
        className="app-content"
      >
        <AppSuspense>
          <AppErrorBoundary>
            {/* {isViewFloating && <FloatingApp />} */}
            {routes}
          </AppErrorBoundary>
        </AppSuspense>
      </Box>
    </AppContentViewWrapper>
  );
};

export default AppContentView;
